import React from 'react';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="w-full px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl border border-slate-200 p-8 mb-6">
            <div className="flex items-center space-x-4 mb-2">
              <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
                <Icon name="FileText" size={20} color="white" strokeWidth={2} />
              </div>
              <h1 className="text-3xl font-bold text-primary">Impressum</h1>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-8 mb-6">
            <h2 className="text-xl font-bold text-primary mb-5">Anschrift</h2>
            <div className="space-y-2 text-text-primary">
              <p className="text-lg font-semibold">ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH</p>
              <p>Kurfürstendamm 14</p>
              <p>10719 Berlin</p>
              <p>Germany</p>
              <p className="pt-4">
                <span className="font-semibold">E-Mail:</span>{' '}
                <a href="mailto:info@advocall.de" className="text-primary hover:text-accent transition-colors">
                  info@advocall.de
                </a>
              </p>
              <p><span className="font-semibold">Geschäftsführer:</span> Mirco Lehr</p>
              <p><span className="font-semibold">Handelsregister:</span> Handelsregister Berlin Charlottenburg</p>
              <p><span className="font-semibold">Verantwortlich für den Inhalt:</span> Mirco Lehr</p>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-8 mb-6">
            <h2 className="text-xl font-bold text-primary mb-5">Rechtliche Hinweise</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">1. Inhalt des Onlineangebotes</h3>
                <p className="text-text-primary leading-relaxed">
                  Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">2. Verweise und Links</h3>
                <p className="text-text-primary leading-relaxed">
                  Bei direkten oder indirekten Verweisen auf fremde Internetseiten (Links), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erklärt daher ausdrücklich, dass zum Zeitpunkt der Linksetzung die entsprechenden verlinkten Seiten frei von illegalen Inhalten waren. Der Autor hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der gelinkten/verknüpften Seiten. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller gelinkten /verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">3. Urheber- und Kennzeichenrecht</h3>
                <p className="text-text-primary leading-relaxed">
                  Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluß zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nichtgestattet.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">4. Rechtswirksamkeit dieses Haftungsausschlusses</h3>
                <p className="text-text-primary leading-relaxed">
                  Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-8 mb-6">
            <h2 className="text-xl font-bold text-primary mb-5">Berufshaftpflichtversicherung</h2>
            <div className="space-y-4 text-text-primary leading-relaxed">
              <p>
                Rechtsanwälte, Steuerberater und Notare sind aufgrund gesetzlicher Bestimmung in der BRAO, BNotO, StBerG verpflichtet, eine Berufshaftpflichtversicherung abzuschließen.
              </p>
              <p>
                Die Mindestversicherungssumme für Rechtsanwaltsgesellschaften beträgt € 2.500.000,00.
              </p>
              <p>
                Die Einzelheiten ergeben sich aus §§ 51,59j Abs. 2 BRAO, 19 a BNotO und § 67 StBerG. Berufshaftpflichtversicherer der ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH ist die
              </p>
              <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
                <p className="font-semibold">Markel Insurance SE</p>
                <p>Sophienstr. 26</p>
                <p>80333 München</p>
              </div>
              <p>
                Der Geltungsbereich der Berufshaftpflichtversicherung ist weltweit.
              </p>
              <p>
                Die Erbringung der Dienstleistungen von AdvoCall erfolgt nach den Regelungen der Allgemeinen Bedingungen für Mandats- und Vergütungsvereinbarungen der ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH. Diese sind an den jeweiligen Niederlassungen der ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH erhältlich.
              </p>
              <p>
                Gemäß § 49b Abs. 5 Bundesrechtsanwaltsordnung (BRAO) besteht bei Wertgebühren eine Hinweispflicht auf die Berechnung der Anwaltsgebühren nach dem Gegenstandswert. Nach dieser Vorschrift ist der RA vor der Übernahme eines Mandats verpflichtet, seinen Mandanten darauf hinzuweisen, wenn sich die Gebühren nach dem Gegenstandswert richten. Sofern wir keine Vergütungsvereinbarung mit Ihnen schließen, erfolgt die Abrechnung nach Gegenstandswert.
              </p>
              <p>
                Zur Festlegung des Leistungsumfangs und der Vergütung schließen wir mit unseren Mandanten darüber hinaus Mandats- und Vergütungsvereinbarungen, welche individuell mit unseren Mandanten ausgehandelt werden.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-8 mb-6">
            <h2 className="text-xl font-bold text-primary mb-5">Weitere Informationen</h2>
            <div className="space-y-4 text-text-primary leading-relaxed">
              <div>
                <h3 className="text-base font-semibold text-primary mb-2">Vermeidung von Interessenkonflikten</h3>
                <p>
                  Die Wahrnehmung widerstreitender Interessen ist Rechtsanwälten aufgrund berufsrechtlicher Regelungen untersagt (§ 43a Abs. 4 BRAO). Vor Annahme eines Mandates wird deshalb immer geprüft, ob ein Interessenkonflikt vorliegt.
                </p>
              </div>

              <div>
                <h3 className="text-base font-semibold text-primary mb-2">Online-Streitbeilegungsplattform und Verbraucherstreitbeilegung</h3>
                <p>
                  Die Europäische Kommission stellt keine Plattform zur Online-Streitbeilegung mehr bereit. Die ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH nimmt nicht an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.
                </p>
              </div>

              <div>
                <h3 className="text-base font-semibold text-primary mb-2">Hinweis zur Sprachform</h3>
                <p>
                  Aus Gründen der besseren Lesbarkeit verzichten wir auf die gleichzeitige Verwendung geschlechterspezifischer Sprachformen. Entsprechende Begriffe gelten im Sinne der Gleichbehandlung grundsätzlich für alle Geschlechter. Die verkürzte Sprachform hat nur redaktionelle Gründe und beinhaltet keine Wertung.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer className="bg-primary text-white py-6 mt-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-white/80">
            © {new Date()?.getFullYear()} ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;